/***
 * checkIsFinalApproverNeeded returns true if current approver is the final approver to approve
 * @param approverId: project object
 * @param milestone: milestone
 * @param projectLeaders: regional 'ProjectLeaders' property from project
 */
export const checkIsFinalApproverNeeded = (
  approverId,
  { approvers, projectLeaderApprovers },
  projectLeaders
) => {
  const unapprovedApprovers = approvers
    ?.filter(
      ({ isDeleted, isNotApplicable, assignedUsers }) =>
        !isDeleted && !isNotApplicable && assignedUsers?.length
    )
    .map(({ assignedUsers }) => assignedUsers)
    .flat()
    .filter(({ approved }) => !approved)
    .map(({ userId }) => userId)
    .filter((id) => id !== approverId);

  if (unapprovedApprovers.length) return false;

  const currentUserIsProjectLeaderOfRegions = Object.keys(projectLeaders)
    .map((region) => approverId === projectLeaders[region] && region)
    .filter((region) => !!region);

  const unapprovedProjectLeaderApprovers = projectLeaderApprovers?.filter(
    ({ isNotApplicable, regionId, assignedUser }) =>
      !isNotApplicable &&
      !currentUserIsProjectLeaderOfRegions.includes(regionId) &&
      !assignedUser?.approved
  );

  return !unapprovedProjectLeaderApprovers.length;
};
